import type { ReactElement } from 'react';

export interface ProgressBarProps {
  completed: number;
  total: number;
}

export function ProgressBar({ completed, total }: ProgressBarProps): ReactElement {
  const pct = total === 0 ? 0 : Math.round((completed / total) * 100);
  return (
    <div className="flex flex-col gap-1" data-testid="shopping-progress">
      <div className="text-xs" style={{ color: 'var(--text-muted)' }}>
        {completed} / {total} completed ({pct}%)
      </div>
      <div
        className="h-2 w-full overflow-hidden rounded-full"
        style={{ background: 'var(--border)' }}
      >
        <div
          className="h-full"
          style={{ width: `${pct}%`, background: 'var(--accent)' }}
          data-testid="shopping-progress-fill"
        />
      </div>
    </div>
  );
}
